<template>
  <div class="grid-item">
  <div class="people-block">
    <div class="people-block__img-mini">
      <img :src="people_item.imageThumb || people_item.image" :alt="people_item.name">
    </div>
    <div class="people-block__information">
      <div class="people-block__information-header">
        <p class="text-TTDrugs-regular-20 text-uppercase color-gray">{{people_item.name}}
        </p>
      </div>
      <div class="people-block__information-position">
        <p class="color-black text-TTDrugs-semi-bold-18">{{ positionWithExperience }}</p>
      </div>
      <div class="people-block__information-position people-block__information-position--qualification" v-if="qualificationCategory">
        <p class="color-black text-TTDrugs-light-18">
          {{ qualificationCategory }}
        </p>
      </div>
      <div class="people-block__information-position" v-if="academicDegree">
        <p class="color-black text-TTDrugs-light-18">
          {{ academicDegree }}
        </p>
      </div>
      <div
        class="people-block__information-position"
        v-if="people_item.mainDepartment !== '' && people_item.mainDepartment "
      >
        <p class="color-black text-TTDrugs-light-18">
          {{ people_item.mainDepartment }}
        </p>
      </div>
      <div
        class="people-block__information-position"
        v-if="people_item.department && people_item.department !== people_item.mainDepartment"
      >
        <p class="color-black text-TTDrugs-light-18">
          {{ people_item.department }}
        </p>
      </div>
      <div
        class="people-block__information-position"
        v-if="people_item.subDepartment && people_item.subDepartment !== people_item.department && people_item.subDepartment !== people_item.mainDepartment"
      >
        <p class="color-black text-TTDrugs-light-18">
          {{ people_item.subDepartment }}
        </p>
      </div>
      <div class="people-block__information-opening-hours" v-if="people_item.opening !== '' && people_item.opening ">
        <p class="text-circe-20"><span class="text-circe-bold-20">Часы приёма:</span> {{people_item.opening}}</p>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import { fullYearsSinceMedicalExperienceStart, yearsDeclensionRu } from '@/helpers/medicalExperience'

  export default {
    name: "AppPeopleItem",
    props: {
      people_item: {
        type: Object,
        required: true
      }
    },
    computed: {
      positionWithExperience() {
        const title = this.people_item.position || ''
        const start = this.people_item.medicalExperienceStartDate
        if (!start) return title
        const years = fullYearsSinceMedicalExperienceStart(start)
        if (years === null) return title
        const st = `стаж ${years} ${yearsDeclensionRu(years)}`
        return title ? `${title}, ${st}` : st
      },
      qualificationCategory() {
        return (
          this.people_item.qualificationCategory ||
          this.people_item.qualification_category ||
          this.people_item.category ||
          ''
        )
      },
      academicDegree() {
        return (
          this.people_item.academicDegree ||
          this.people_item.academic_degree ||
          ''
        )
      },
    },
  };
</script>
